import { Box, Skeleton } from '@mui/material';

const skeletonContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px'
} as const;

export const FeedArticleDialogSkeleton = () => (
  <Box
    data-testid='skeleton'
    sx={skeletonContainerStyles}
  >
    <Skeleton
      height={24}
      width='75%'
    />
    <Skeleton
      height={14}
      width='45%'
    />

    <Skeleton
      height={24}
      width='25%'
    />
    <Skeleton height={16} />
    <Skeleton height={16} />
    <Skeleton height={16} />
    <Skeleton
      height={24}
      width='25%'
    />
    <Skeleton height={16} />
    <Skeleton height={16} />
    <Skeleton height={16} />
  </Box>
);
